import styled from "styled-components"
import { useState, lazy, Suspense, useMemo } from "react";
import { urlPaths } from "../../utils/config";
import { Helmet } from 'react-helmet-async';
import ResultBanner from "../../assets/resultpage/resultBanner.png";
import ResultFeature from "../../assets/WhiteBakgroundDust.jpg";
import SettingAi from "../../assets/resultpage/AiSetting.png";
import StayFocus from "../../assets/resultpage/StayFocused.png";
import Tone from "../../assets/resultpage/tone.png";
import standout from "../../assets/resultpage/standout.png";
import shortReply from "../../assets/resultpage/shortReply.png";
import Ideas from "../../assets/resultpage/idea.png";
import Engagemnt from "../../assets/resultpage/engagemnt.png";
import Grammer from "../../assets/resultpage/grammer.png";
import Meta from "../../assets/resultpage/meta.png";
import Multiplelang from "../../assets/resultpage/multiplelang.png";
import RightCmnt from "../../assets/resultpage/RightCmnt.png";
import SaveCommnt from "../../assets/resultpage/saveCommnt.png"
import Smartreply from "../../assets/resultpage/smartreply.png";





const Feature = () => {
  
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Results",
        "url": "https://commenter.ai/results",
        "description": "See the impact of AI LinkedIn comments. Learn how our tool can help you grow your LinkedIn presence and save time.",
        "about": {
          "@type": "Organization",
          "name": "Commenter.ai",
          "url": "https://commenter.ai"
        }
      };
   
    return (
        <>
        <Helmet>
          <script type="application/ld+json">
          {JSON.stringify(structuredData)}
          </script>
        </Helmet>
         
        <DriveResults>
            <Container>
              <ButtonResluts>
              AI features that make LinkedIn easier
              </ButtonResluts>
              <HeadingOne>
                Comments That Get Results & Save You Time!
              </HeadingOne>
              <HeadingSmall>
              Our AI-powered tool doesn&rsquo;t just save you hours - it helps you make every comment count. Whether you want to sound more natural, reach more people, or try new ways to engage, this tool has everything you need.
              </HeadingSmall>
            </Container>
        </DriveResults>
        <Features>
            <Container>
               
                <WordStyle>
                    Your Words, Your Style
                </WordStyle>
                <AiLearn>
                    The AI learns how you write, so your comments sound just like you!
                </AiLearn>

                <Aisettings>
                    <img className="bgImage" src={SettingAi} alt="AIsettings" />  
                </Aisettings>
                <RightTextLayout>
                <div className="imagebanner">
                    <img className="imagewidth" src={StayFocus} alt="StayFocus" />  
                </div>
                <div className="contentContainer">
                    <h2>Stay Focused on What Matters</h2>
                    <h3>Create a LinkedIn feed with only the posts that help you grow - no distractions.</h3>
                </div>
                </RightTextLayout>
                <LeftTextLayout>
                <div className="contentContainer">
                        <h2>Try Different Tones</h2>
                        <h3>Want to be funny, creative, or even a little bold? Test different styles to see what works best!</h3>
                    </div>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Tone} alt="StayFocus" />  
                    </div>
                </LeftTextLayout>
                <RightTextLayout>
                    <div className="imagebanner">
                        <img className="imagewidth" src={standout} alt="StayFocus" />  
                    </div>
                    <div className="contentContainer">
                        <h2>Stand Out with the Right Commenting Style</h2>
                        <h3>Use attention-grabbing comment styles or go with a simple, friendly tone - it&rsquo;s up to you!</h3>
                    </div>
                </RightTextLayout>
                <LeftTextLayout>
                <div className="contentContainer">
                        <h2>Turn Ideas Into Comments</h2>
                        <h3>Have a thought but don&rsquo;t know how to write it? AI turns your ideas into perfect comments.</h3>
                    </div>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Ideas} alt="StayFocus" />  
                    </div>
                </LeftTextLayout>
                <RightTextLayout>
                    <div className="imagebanner">
                        <img className="imagewidth" src={RightCmnt} alt="StayFocus" />  
                    </div>
                    <div className="contentContainer">
                        <h2>Choose the Right Comment Length</h2>
                        <h3>Some posts need a short reply, others need more details. Pick what fits best.</h3>
                    </div>
                </RightTextLayout>
                <LeftTextLayout>
                <div className="contentContainer">
                        <h2>Comment in Multiple Languages</h2>
                        <h3>Want to connect with people who don&rsquo;t speak English? AI helps you comment in different languages that use the Latin alphabet.</h3>
                    </div>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Multiplelang} alt="StayFocus" />  
                    </div>
                </LeftTextLayout>
                <RightTextLayout>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Smartreply} alt="StayFocus" />  
                    </div>
                    <div className="contentContainer">
                        <h2>Smart Replies That Keep Conversations Going</h2>
                        <h3>AI-powered replies help you engage without spending extra time.</h3>
                    </div>
                </RightTextLayout>
                <LeftTextLayout>
                <div className="contentContainer">
                        <h2>Works on Linkedin, X, Instagram & Meta</h2>
                        <h3>Engage on multiple platforms now - with more coming soon!</h3>
                    </div>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Meta} alt="StayFocus" />  
                    </div>
                </LeftTextLayout>
                <RightTextLayout>
                    <div className="imagebanner">
                        <img className="imagewidth" src={SaveCommnt} alt="StayFocus" />  
                    </div>
                    <div className="contentContainer">
                        <h2>Save & Reuse Your Best Comments</h2>
                        <h3>If a comment gets great engagement, save it! You can even turn it into a post later.</h3>
                    </div>
                </RightTextLayout>
                <LeftTextLayout>
                <div className="contentContainer">
                        <h2>No More Typos!</h2>
                        <h3>AI checks your grammar so your comments always look polished and professional.</h3>
                    </div>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Grammer} alt="StayFocus" />  
                    </div>
                </LeftTextLayout>
                <RightTextLayout>
                    <div className="imagebanner">
                        <img className="imagewidth" src={Engagemnt} alt="StayFocus" />  
                    </div>
                    <div className="contentContainer">
                        <h2>Keep Track of Who You Engage With</h2>
                        <h3>Make a list of people you interact with, their posting times, and notes - all in one place!</h3>
                    </div>
                </RightTextLayout>
                <LessEfforts>
                    <h2>More Engagement, Less Effort!</h2>
                    <h3>Comment faster, better, and smarter - so you can grow without wasting time online.</h3>
                    <h4>Try it today and see the magic!</h4>
                    <button>Start Achieving Results With Your Comments</button>
                </LessEfforts>
            </Container>
        </Features>
       
        </>
    )
}

const Container = styled.div`
    max-width:1170px;
    margin: auto;
    width: 100%;
`
const DriveResults = styled.div`
   background-image: url(${ResultBanner});   
   padding:100px 15px;
   background-size: cover;

   @media only screen and (max-width:1023px){
        padding:60px 15px;
   }
    @media only screen and (max-width:767px){
        padding:40px 15px;
   }
`
const ButtonResluts = styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 34px;
    letter-spacing: 1px; /* Fixed */
    text-align: center;
    text-transform: capitalize;
    color: #1E54A5;
    max-width: fit-content;
    min-height: 70px;
    border-radius: 10px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    margin: auto;
    font-family: 'Roboto Slab', sans-serif;
    border: 2px solid white; /* Fixed from transparent */
    background-clip: padding-box;
    @media only screen and (max-width:767px){
       font-size: 16px;
    }

    &::before {
        content: "";
        position: absolute;
        inset: -2px;
        border-radius: 10px;
        border: 2px dashed #1E54A5;
        background: transparent;
    } 
    
    `

const HeadingOne = styled.div`
    font-family: Roboto Slab;
    font-weight: 500;
    font-size: 65px;
    line-height: 75px;
    letter-spacing: -3%;
    text-align: center;
    text-transform: capitalize;
    color:#FFFFFF;
    max-width: 1000px;
    margin:50px auto;
    @media only screen and (max-width:1023px){
        font-size: 45px;
        line-height: 55px;
    }
    @media only screen and (max-width:767px){
        font-size: 36px;
        line-height: 46px;
        margin:30px auto;
    }
`  
const HeadingSmall = styled.div`
    font-family: Roboto Slab;
    font-weight: 800;
    font-size: 36px;
    line-height: normal;
    letter-spacing: 0%;
    text-align: center;
    color:#FFFFFF;
    @media only screen and (max-width:1023px){
        font-size: 32px;
        line-height: 42px;
    }
    @media only screen and (max-width:1023px){
        font-size: 22px;
        line-height: 33px;
    }
` 
const Features = styled.div`
    padding:100px 15px;
    background-image: url(${ResultFeature});   
    background-size: contain;
    background-repeat:repeat;
    @media only screen and (max-width:1023px){
       padding:60px 15px;
    }
    @media only screen and (max-width:767px){
       padding:40px 15px;
    }
`
const Featureheading = styled.div`
    font-family: Roboto Slab;
    font-weight: 500;
    font-size: 50px;
    line-height: 60px;
    letter-spacing: -3%;
    text-align: center;
    text-transform: capitalize;
    color: #000000;
    @media only screen and (max-width:1023px){
        font-size: 45px;
        line-height: 55px;
    }
    @media only screen and (max-width:1023px){
        font-size: 35px;
        line-height: 45px;
    }
` 

const  WordStyle = styled.div`
    font-family: 'Open Sans', sans-serif;
    font-weight: 800;
    font-size: 30px;
    line-height: normal;
    letter-spacing: 0%;
    text-align: center;
   
` 

const AiLearn = styled.div`
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: 30px;
    line-height: normal;
    letter-spacing: 0%;
    text-align: center;
    max-width: 850px;
    margin: auto;
    margin-top:20px;
` 
const Aisettings = styled.div`
    position:relative;
    > .bgImage{
        position:relative;
        width:100%;
    }  
` 
const RightTextLayout = styled.div`
    display:flex;
    align-items: center;
    padding:80px 0;
    gap:30px;
    @media only screen and (max-width:1023px){
        flex-direction:column;
        gap:20px;
        padding:60px 0;
    }
    @media only screen and (max-width:1023px){
        padding:40px 0;
    }

    >div{
        width:100%;
         >img.imagewidth {
            width: 100%;
        }
        > h2{
            font-family: 'Open Sans', sans-serif;
            font-weight: 800;
            font-size: 30px;
            line-height: normal;
            letter-spacing: 0%;
            color: #000000; 
            @media only screen and (max-width:1023px){
              font-size: 22px;
            }
            @media only screen and (max-width:767px){
              font-size: 18px;
              line-height: normal;
            }
        }
        >h3 {
            font-family: 'Open Sans', sans-serif;
            font-weight: 700;
            font-size: 30px;
            line-height: normal;
            letter-spacing: 0%;
            color: #000000; 
            @media only screen and (max-width:1023px){
              font-size: 22px;
            }
            @media only screen and (max-width:767px){
               font-size: 18px;
               line-height: normal;
            }
        }
    }
` 
const LeftTextLayout = styled.div`
    display:flex;
    align-items: center;
    gap:30px;
    @media only screen and (max-width:1023px){
        flex-direction:column-reverse;
        gap:20px;
        padding:60px 0;
    }
    @media only screen and (max-width:1023px){
        padding:0px 0;
    }

    >div{
        width:100%;
         >img.imagewidth {
            width: 100%;
        }
        > h2{
            font-family: 'Open Sans', sans-serif;
            font-weight: 800;
            font-size: 30px;
            line-height: normal;
            letter-spacing: 0%;
            color: #000000; 
        @media only screen and (max-width:1023px){
            font-size: 22px;
        }
        @media only screen and (max-width:767px){
            font-size: 18px;
            line-height: normal;
        }
        }
        >h3 {
            font-family: 'Open Sans', sans-serif;
            font-weight: 700;
            font-size: 30px;
            line-height: normal;
            letter-spacing: 0%;
            color: #000000; 
        @media only screen and (max-width:1023px){
            font-size: 22px;
        }
        @media only screen and (max-width:767px){
            font-size: 18px;
            line-height: normal;
        }
        }
    }
`
const LessEfforts = styled.div`
    box-shadow: 10px 10px 0px 0px #5BB7E7;
    background: #fff;
    padding: 80px 80px;
    border-radius: 20px;
    text-align: center;
    width: calc(100% - 15px);
    box-sizing: border-box;
    margin: auto;
    @media only screen and (max-width:1023px){
         padding: 60px 60px;
    }
    @media only screen and (max-width:1023px){
    padding:15px;
    }
    >h2{
        font-family: Roboto Slab;
        font-weight: 500;
        font-size: 50px;
        line-height: 60px;
        letter-spacing: -3%;
        text-align: center;
        text-transform: capitalize;
        color: #000000;
        @media only screen and (max-width:1023px){
            font-size: 40px;
            line-height: 50px;
            margin:0;
        }
            @media only screen and (max-width:1023px){
            font-size: 32px;
            line-height: 42px;
        }
    }
    >h3{
        font-family: Open Sans;
        font-weight: 800;
        font-size: 30px;
        line-height: normal;
        letter-spacing: 0%;
        text-align: center;
        color: #000000;
        margin-top:50px;
        @media only screen and (max-width:1023px){
            font-size: 22px;
        }
        @media only screen and (max-width:1023px){
            margin-top:30px;
        }
    }
    >h4{
        font-family: Open Sans;
        font-weight: 700;
        font-size: 30px;
        line-height: normal;
        letter-spacing: 0%;
        color: #000000;
        margin-top:30px;
         @media only screen and (max-width:1023px){
            font-size: 22px;
        }
    }
    >button{
        margin-top:50px;
        background: #5BB7E7;
        max-width: 628px;
        min-height: 55px;
        border-radius: 10px;
        font-family: Roboto Slab;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0%;
        vertical-align: middle;
        text-transform: uppercase;
        color: #FFFFFF;
        padding:15px;
        box-sizing:border-box;
        border:0px;
        @media only screen and (max-width:767px){
            font-size: 16px;
        }
         @media only screen and (max-width:1023px){
            margin-top:0px;
        }
    }
}
` 

export default Feature;